import React, { useCallback, useEffect, useRef, useState } from 'react'
import CustomModal from '../../modal/CustomModal'
import Button from '../../buttons/Button'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { BeeperCodeButtonsWrapper, BeeperCodeModalWrapper, ErrorText, ErrorTextWrapper, InputBeeperCodeWrap } from './index.styled'
import { selectBeeperRequired } from '../../../../redux/selector/cart'
import { handleValidateBeeperValue } from './helper'
import Keyboard from './BeeperKeyboard'

const EVENT_Z_INDEX = 125

const ModalBeeperCode = React.memo(({ isOpen, module, onClose, onActivate, orderBeeperCode }) => {
	const { t } = useTranslation()
	const inputBeeperCode = useRef()
	const [beeperCode, setBeeperCode] = useState('')
	const isBeeperRequired = useSelector(selectBeeperRequired(module))
	const errorText = handleValidateBeeperValue(beeperCode, isBeeperRequired, t)
	const layout = (errorText ? ' error' : '')

	useEffect(() => {
		if (isOpen && orderBeeperCode) {
			setBeeperCode(orderBeeperCode)
		}
	}, [isOpen, orderBeeperCode])

	const handleBeeperCodeChange = useCallback((value) => {
		setBeeperCode(value)
	}, [])

	const handleClose = useCallback(() => {
		setBeeperCode('')
		onClose()
	}, [onClose])

	const handlePayment = useCallback(() => {
		onActivate(beeperCode ? beeperCode : null)
		handleClose()
	}, [handleClose, beeperCode, onActivate])

	return (
		<>
			<CustomModal isOpen={isOpen}
									 close={handleClose}
									 title={t('Cart.BeeperCode.title')}
									 zIndex={EVENT_Z_INDEX}
									 showBackButton={false}
									 disableBackButton={true}
									 size="auto">
				<BeeperCodeModalWrapper>
					<InputBeeperCodeWrap className={layout}>
						<input name="beeperCode"
									 onChange={handleBeeperCodeChange}
									 value={beeperCode}
									 ref={inputBeeperCode}
									 placeholder={t('Cart.BeeperCode.title')}
									 autoFocus={true}
									 readOnly={true} />
					</InputBeeperCodeWrap>
					<ErrorTextWrapper>
						{errorText && <ErrorText>{errorText}</ErrorText>}
					</ErrorTextWrapper>
					<Keyboard handleType={handleBeeperCodeChange}
										currentValue={beeperCode} />
					<BeeperCodeButtonsWrapper>
						<Button name="back" icon="back" text={t('buttons.controls.back')} onClick={handleClose} keyButton="Escape" keyText="esc" zIndex={EVENT_Z_INDEX} className="back" />
						<Button onClick={handlePayment} text={t('buttons.controls.next')}
										keyButton="F2"
										color="green" name="handleOrderProcessing"
										zIndex={EVENT_Z_INDEX}
										disabled={errorText} />
					</BeeperCodeButtonsWrapper>
				</BeeperCodeModalWrapper>
			</CustomModal>
		</>
	)
})
ModalBeeperCode.displayName = 'ModalBeeperCode'
export default ModalBeeperCode
